// Motion timing for the image modal V2 toolbar surfaces and modal-owned toasts.

/** Toolbar surface enter/exit transition duration. */
export const IMAGE_MODAL_V2_TOOLBAR_MOTION_DURATION_MS = 100;

/** Fallback used to force a toolbar surface's exit complete if no matching `transitionend` arrives. */
export const IMAGE_MODAL_V2_TOOLBAR_EXIT_FALLBACK_MS = 50;

/** Hold after a modal toast leaves before its toolbar replacement begins entering. */
export const IMAGE_MODAL_V2_TOAST_EXIT_HANDOFF_HOLD_MS = 100;

/** Fallback used to force a modal toast's exit complete if no matching `transitionend` arrives. */
export const IMAGE_MODAL_V2_TOAST_EXIT_FALLBACK_MS = 150;
